const Direction = {
    y: "y",
    x: "x",
}

export const animate = (options) => {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { duration = 300, draw = () => {}, timing = (_p) => _p } = options

    let stopKey = false

    var start = performance.now()

    let reqID = requestAnimationFrame(function animate(time) {
        // timeFraction от 0 до 1
        var timeFraction = (time - start) / duration
        if (timeFraction > 1) timeFraction = 1

        // текущее состояние анимации
        var progress = timing(timeFraction)

        draw(progress)

        if (timeFraction < 1 && stopKey === false) {
            reqID = requestAnimationFrame(animate)
        } else {
            if (options.end) options.end()
        }
    })

    const stop = () => {
        stopKey = true

        cancelAnimationFrame(reqID)
    }

    return {
        stop,
    }
}

export const animateDom = (dom, params, options = {}) => {
    const names = Object.keys(params)

    const fromValues = names.map((name) => dom[name])
    const toValues = names.map((name) => params[name])
    const ranges = names.map(
        (name, index) => toValues[index] - fromValues[index]
    )

    return animate({
        ...options,
        draw: (progress) => {
            names.forEach((name, index) => {
                const start = fromValues[index]
                const range = ranges[index]
                const value = start + range * progress

                dom[name] = value
            })
        },
    })
}

export const animateStyle = (dom, params, options = {}) => {
    const names = Object.keys(params)

    const fromValues = names.map((name) => dom.style[name])
    const toValues = names.map((name) => params[name])
    const ranges = names.map(
        (name, index) => toValues[index] - fromValues[index]
    )

    const { transformValue = (v) => v, ...otherOptions } = options

    return animate({
        ...otherOptions,
        draw: (progress) => {
            names.forEach((name, index) => {
                const start = fromValues[index]
                const range = ranges[index]
                const value = start + range * progress

                dom.style[name] = transformValue(value)
            })
        },
    })
}

export const animateValues = (params, draw, options = {}) => {
    const names = Object.keys(params)

    const fromValues = names.map((name) => params[name].from)
    const toValues = names.map((name) => params[name].to)
    const ranges = names.map(
        (name, index) => toValues[index] - fromValues[index]
    )

    return animate({
        ...options,
        draw: (progress) => {
            names.forEach((name, index) => {
                const start = fromValues[index]
                const range = ranges[index]
                const value = start + range * progress

                draw(name, value)
            })
        },
    })
}

export function scrollTo({ element, to, duration = 250 }) {
    const easeInOutQuad = function (t, b, c, d) {
        t /= d / 2
        if (t < 1) return (c / 2) * t * t + b
        t--
        return (-c / 2) * (t * (t - 2) - 1) + b
    }

    if (element) {
        let start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20

        const animateScroll = function () {
            currentTime += increment
            var val = easeInOutQuad(currentTime, start, change, duration)
            element.scrollTop = val
            if (currentTime < duration) {
                setTimeout(animateScroll, increment)
            }
        }
        animateScroll()
    }

    return
}

export const scrollToTop = (value = 0) => {
    const start = window.pageYOffset

    const range = value ? value : -start

    animate({
        draw: (progress) => {
            window.scrollTo(0, start + range * progress)
        },
    })
}
